<template>
    <div class="page-about">
        <SupportList />
        <!--banner-->
        <div class="banner">
            <div class="container">
                <h2 class="timeline">关于我们</h2>
            </div>
        </div>
        <!--start-about-->
        <div class="about">
            <div class="container">
                <div class="about-bottom">
                    <p>Git游戏 旨在发现、收录GitHub上面好玩的 <font color="red">网页游戏</font>，然后进行汉化，方便中文区玩家游戏。</p>
                    <p>如果你对游戏汉化感兴趣，或者自己也是一位游戏开发者（学习者），我们热烈欢迎您的加入。</p>
                    <p>本汉化团队成员都是游戏爱好者自行加入的，汉化纯属爱好，没有薪资报酬的哦。</p>
                        <p>注意：因为Flash、Unity 3D游戏的特殊性，咱们技术所限，所以无法进行汉化，敬请谅解。</p>
                    <p>本站所有游戏收集于互联网，版权归原作者所有。如果侵犯了您的权益，请联系 g8hh@qq.com 删除。</p>
                    <p>欢迎大家推荐好玩的游戏！欢迎各位独立游戏开发者投稿，咱们可以帮你宣传。</p>
                    <p><a href="javascript:void(0)"  class="dashang" title="如果您喜欢我们的游戏，欢迎支持一下我们" @click="open()">赞助支持</a></p>
                    <p><router-link to="/support" target="_blank" style="color:gray;text-decoration: underline;">查看赞助支持者列表</router-link>
                    </p>
                    <!--<div class="about-btm">-->
                        <!--<div class="col-md-6 about-left">-->
                            <!--<a href="article/cat.html"><img class="img-responsive" src="images/game/cat/face.jpg" alt="" /></a>-->
                        <!--</div>-->
                        <!--<div class="col-md-6 about-right">-->
                            <!--<a href="article/cuipi.html"><img class="img-responsive" src="images/game/cuipi/face.jpg" alt="" /></a>-->
                        <!--</div>-->
                        <!--<div class="clearfix"></div>-->
                    <!--</div>-->
                </div>

                <!--team-->
                <div class="team-us">
                    <div class="team-top ">
                        <br><br>
                        <h3>加入我们</h3>
                        <p>> 排名不分先后 <</p>
                    </div>
                    <div class="team-bottom">
                        <ul class="ch-grid">
                            <li v-for="(user,index) in userList" :key="index">
                                <div class="ch-item" :style="'background: url(static/images/about/team-'+user.order+'.jpg);background-position:center;'">
                                    <div class="ch-info-wrap">
                                        <div class="ch-info" :title="user.desc">
                                            <div class="ch-info-front" :style="'background: url(static/images/about/team-'+user.order+'.jpg);backface-visibility:hidden;background-position:center;'"></div>
                                            <div class="ch-info-back">
                                                <h3>{{user.name}}</h3>
                                                <p>{{user.desc}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li><li>
                                <div class="ch-item ch-img-99">
                                    <div class="ch-info-wrap">
                                        <div class="ch-info">
                                            <div class="ch-info-front ch-img-99"></div>
                                            <div class="ch-info-back">
                                                <h3>虚位以待</h3>
                                                <p>就等你来</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!--//team-->
        <!--//about-->
        <!--联系方式-->
        <div class="contact">
            <div class="container">
                <h3>联系方式</h3>
                <div class="address">
                    <div class=" address-more">
                        <h4></h4>
                        <div class="col-md-4 address-grid ">
                            <i class="glyphicon glyphicon-thumbs-up"></i>
                            <div class="address1">
                                <p>公众号</p>
                                <p><a href="https://mp.weixin.qq.com/s/ezp5x6hOC8QPLnZ2bPFyEw" target="_blank">Git游戏</a></p>
                            </div>
                            <div class="clearfix"> </div>
                        </div>
                        <div class="col-md-4 address-grid">
                            <i class="glyphicon glyphicon-globe"></i>
                            <div class="address1">
                                <p>微博</p>
                                <p><a href="https://weibo.com/idlegame" target="_blank">@Git游戏</a></p>
                            </div>
                            <div class="clearfix"> </div>
                        </div>
                        <div class="col-md-4 address-grid ">
                            <i class="glyphicon glyphicon-comment"></i>
                            <div class="address1">
                                <p>QQ群</p>
                                <p><a href="//qm.qq.com/cgi-bin/qm/qr?k=AnZJbnsU8BsmQGGEWs4rXd-JuSJI-j9c&jump_from=webapi" target="_blank" title="点击加入Git游戏放置交流群">793344327</a></p>
                            </div>
                            <div class="clearfix"> </div>
                        </div>
                        <div class="clearfix"> </div>
                    </div>
                </div>
                <div class="address">
                    <div class=" address-more">
                      <div class="col-md-4 address-grid ">
                        <i class="glyphicon glyphicon-facetime-video"></i>
                        <div class="address1">
                          <p>B站</p>
                          <p><a href="https://space.bilibili.com/382827907" target="_blank">@好阳光的小锅巴</a></p>
                        </div>
                        <div class="clearfix"> </div>
                      </div>
                        <div class="col-md-4 address-grid ">
                            <i class="glyphicon glyphicon-envelope"></i>
                            <div class="address1">
                                <p>邮箱</p>
                                <p><a href="mailto:g8hh@qq.com" target="_blank">g8hh@qq.com</a></p>
                            </div>
                            <div class="clearfix"> </div>
                        </div>
                        <div class="clearfix"> </div>
                    </div>
                </div>

                <div class="clearfix"> </div>

            </div>
        </div>
        <!--联系方式-->
    </div>
</template>

<script>
import SupportList from '@/components/Support.vue'
export default {
  name: 'Demo',
  components: { SupportList },
  data() {
    return {
      userList: []
    }
  },
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    getData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/user.json' + '?' + timeStamp).then(res => {
        if (res.data) {
          var data = []
          res.data.forEach(el => {
            if (el.status !== 0) {
              data.push(el)
            }
          })
          this.userList = data
        }
      },
      res => {
        console.log('error')
      }
      )
    },
    open() {
      $('.hide_box').fadeIn()
      $('.shang_box').fadeIn()
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/About.vue